import React from 'react'
import 'index.css'
import Form from './compenents/Form'

export const App = () => {
  return <Form />
}